import Call from '../Call.v2';
import {objToQs} from '../Utils';

const BidderManualOffers = {
    get() {
        return Call(`bidder/manualOffers`);
    },

    save(event) {
        return Call(`bidder/manualOffers`, 'POST', event);
    },

    update(id, event) {
        return Call(`bidder/manualOffers/${id}`, 'PUT', event);
    },

    remove(id) {
        return Call(`bidder/manualOffers/${id}`, 'DELETE');
    },
};

export default BidderManualOffers;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderManualOffers.js